import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCodeLines"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H13.95V5.5H2V4ZM17 4H22V5.5H17V4ZM2 11.25H9V12.75H2V11.25ZM12 11.25H22V12.75H12V11.25ZM2 18.5H11V20H2V18.5ZM14 18.5H22V20H14V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeLines;
